import {Route} from '@angular/router';
import {AuthentificationAfterComponent} from './authentification-after.component';

export const authentificationAfterRoute: Route = {
    path: 'authentification/callback',
    component: AuthentificationAfterComponent,
    title: 'authentication.after.title',
};
